import { render, staticRenderFns } from "./resendEmailK3l.vue?vue&type=template&id=08bdb1e0&"
import script from "./resendEmailK3l.vue?vue&type=script&lang=js&"
export * from "./resendEmailK3l.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports